<template>
  <div>
    <h4 class="co-display-10 mb-5 text-center">
      参加条件
    </h4>
    <div class="co-container-sm mb-[3.25rem] text-center">
      <ul
        class="inline-block w-auto list-disc rounded border-[#fff3cd] bg-[#fff3cd] p-5 text-left font-bold text-[#856404]"
        style="list-style-position: inside"
      >
        <slot name="conditionList">
          <li class="mb-2">
            必要なメンタリング回数をこなすことが出来る
          </li>
          <li class="mb-2">
            期間内に必要な学習時間を確保出来る
          </li>
          <li class="mb-2">
            MacかWindowsのPCを持っている
          </li>
          <li class="mb-2">
            Macの場合：OS Ventura 13 以上
          </li>
          <li class="mb-2">
            Google Chrome を利用できる
          </li>
          <li class="mb-2">
            PCの基本的な操作が問題なくできる
          </li>
          <li>ビデオチャットが可能な通信環境</li>
        </slot>
      </ul>
    </div>
  </div>
</template>
